function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Circle_Button_-_Corner",
  "data-name": "Circle Button - Corner",
  transform: "translate(31.36 0.461) rotate(90)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Area",
  transform: "translate(-0.461 0.36)",
  fill: "none",
  stroke: "#61af5f",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 31,
  rx: 15.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(8.172 8.942)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Area-2",
  "data-name": "Area",
  width: 13.896,
  height: 13.896,
  fill: "#fcfcfc",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-2",
  "data-name": "Icon",
  transform: "translate(2.895 2.895)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line",
  x2: 8.106,
  transform: "translate(0 4.053)",
  fill: "none",
  stroke: "#61af5f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0,4.053,4.053,0,8.105",
  transform: "translate(4.053)",
  fill: "none",
  stroke: "#61af5f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}))));

function SvgCircleArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDown);
export default __webpack_public_path__ + "static/media/circle-arrow-down.6c71c995.svg";
export { ForwardRef as ReactComponent };